import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

import { useErrorHandler } from "../../../_metronic/helpers/ErrorHandler";
import { Content } from "../../../_metronic/layout/components/Content";
import { useAuth } from "../auth/core/Auth";
import { Toolbar } from "./Toolbar";
import ListUsers from "./ListUsers";
import AssignAmbients from "./AssignResource";
import * as ResellerService from "./services/ResellerService";
import "./Reseller.scss";

const ResellerModule = () => {
    const { currentUser } = useAuth();
    const { errorHandler } = useErrorHandler();
    const [ open, setOpen ] = useState(false);
    const [ user, setUser ] = useState(null);
    const [ loading, setLoading ] = useState(true);
    const [ users, setUsers ] = useState([]);
    const load = () => {
        errorHandler(ResellerService.listUser()).then(res => {
            if (res.ok) {
                setUsers(res.data.data);
            }
            setLoading(false);
        });
    }
    useEffect(() => {
        if (currentUser?.reseller) {
            load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser?.reseller])

    if (!currentUser?.reseller) {
        return <Navigate to="/gis" replace />;
    }

    return (
        <>
        {/*<PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>*/}
        <div id='kt_content' className='p-0 content d-flex flex-column flex-column-fluid reseller-module'>
            <Toolbar onInvite={() => load()} />
            <AssignAmbients loadUsers={load} open={open} setOpen={setOpen} user={user} />
            <div className='post d-flex flex-column-fluid reseller-module__post' id='kt_post'>
                <Content>
                    <ListUsers setOpen={setOpen} setUser={setUser} users={users} loading={loading} />
                </Content>
            </div>
        </div>
        </>
    );
};

export { ResellerModule };
